import axios from "axios";
import {OUTBOUND_ITEM_DETAIL_LIST_URL} from '../../config/stck.links'
import {toast} from 'react-toastify'

export const FETCH_OUTBOUND_ITEM_DETAIL_LIST = 'FETCH_OUTBOUND_ITEM_DETAIL_LIST'
export const RECEIVE_OUTBOUND_ITEM_DETAIL_LIST = 'RECEIVE_OUTBOUND_ITEM_DETAIL_LIST'
export const FAILED_OUTBOUND_ITEM_DETAIL_LIST = 'FAILED_OUTBOUND_ITEM_DETAIL_LIST'

export function fetchOutboundItemDetail(_id){
    return (dispatch, getState) => {
        let auth = getState().authStore.authData.result.token;
        dispatch({type: FETCH_OUTBOUND_ITEM_DETAIL_LIST});
        axios({
            method: 'post',
            url: OUTBOUND_ITEM_DETAIL_LIST_URL,
            headers: {
                Authorization: auth
            },
            data:{
                id_master_outbound: _id
            }
        })
        .then((response) => {
            dispatch( {
                type: RECEIVE_OUTBOUND_ITEM_DETAIL_LIST,
                payload: response.data
            })
        })
        .catch(function(error){
            if (error.response) {
                if(error.response.status === 401) {
                    dispatch({
                        type: FAILED_OUTBOUND_ITEM_DETAIL_LIST
                    })
                    return toast.error("Invalid username or password! Please try again!");
                } else if (error.response.status === 404 || error.response.status === 500) {
                    dispatch({
                        type: FAILED_OUTBOUND_ITEM_DETAIL_LIST
                    })
                    return toast.error("Server cannot be contacted! Please ask your system administrator!");
                } else if (error.response.status === 400) {
                    dispatch({
                        type: FAILED_OUTBOUND_ITEM_DETAIL_LIST
                    })
                    return toast.error(error.response.data.message);
                } else {
                    dispatch({
                        type: FAILED_OUTBOUND_ITEM_DETAIL_LIST
                    })
                    return toast.error('Something went wrong... Please try again later...');
                }
            } else if (error.request) {
                dispatch({
                    type: FAILED_OUTBOUND_ITEM_DETAIL_LIST
                })
                return toast.error('Request error! Please try again later...')
            } else {
                dispatch({
                    type: FAILED_OUTBOUND_ITEM_DETAIL_LIST
                })
                return toast.error('Something went wrong... Please try again later...')
            }
        })
    }
}